var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductionImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 103,
    viewBox: "0 0 117 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2631 41.1641H1V102H22.2631V84.2808H115.584V59.4739H22.2631V41.1641Z",
    fill: "white",
    stroke: "#005B7F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5322 39.9823V1H41.1638V39.9823H30.5322Z",
    fill: "white",
    stroke: "#005B7F",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5322 41.9667V51.7949L41.1638 45.6523V36.4383L30.5322 41.9667Z",
    fill: "#005B7F",
    stroke: "#005B7F",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3076 46.0273L24.2156 45.3193L24.8081 43.5269L25.6465 45.3193L27.3085 46.0273L25.6465 46.7503L24.8081 48.5278L24.2156 46.7503L22.3076 46.0273Z",
    fill: "#FF8646"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5254 53.6582L40.4333 52.9502L41.0258 51.1578L41.8643 52.9502L43.5263 53.6582L41.8643 54.3811L41.0258 56.1586L40.4333 54.3811L38.5254 53.6582Z",
    fill: "#FF8646"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1221 57.4746L28.03 56.7666L28.6225 54.9742L29.461 56.7666L31.123 57.4746L29.461 58.1975L28.6225 59.9751L28.03 58.1975L26.1221 57.4746Z",
    fill: "#FF8646"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7549 46.9805L35.6628 46.2724L36.2553 44.48L37.0938 46.2724L38.7558 46.9805L37.0938 47.7034L36.2553 49.4809L35.6628 47.7034L33.7549 46.9805Z",
    fill: "#FF8646"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5381 54.6123L19.446 53.9043L20.0385 52.1119L20.877 53.9043L22.539 54.6123L20.877 55.3352L20.0385 57.1127L19.446 55.3352L17.5381 54.6123Z",
    fill: "#FF8646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionImg);
export default __webpack_public_path__ + "static/media/productionIMG.dee699d5d3210a37e09b549d832c3804.svg";
export { ForwardRef as ReactComponent };